// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29509","label":"styles_label__-PSTJ"};